import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
  Select,
  Box,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CustomSelect from "../../components/customFields/CustomSelect";
import CustomTextField from "../../components/customFields/CustomTextField";
import CustomSelectField from "../../components/customFields/CustomSelectField";
import InfoIcon from "@mui/icons-material/Info";
import PrimaryButon from "../../components/customButtons/PrimaryButon";
import GlobalRadioGroup from "../../components/radioButtons/GlobalRadioGroup";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import GroupIcon from "@mui/icons-material/Group";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DescriptionIcon from "@mui/icons-material/Description";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArticleIcon from "@mui/icons-material/Article";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import SearchButton from "../../components/customButtons/SearchButton";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  bookDemo,
  getBranchList,
  getDeliveryModes,
  getSubTestTypeList,
  getTestDeliveryFormat,
  getTestTypeList,
  searchDemo,
} from "../testPrepDashboard/Api/DashboardApi";
import { useForm, Controller } from "react-hook-form";
import Loader from "../../../SAPPages/components/Loader/Loader";
import ConfirmationScreen from "../../components/customPopup/ConfirmationScreen";
import DemoConfimationScreen from "./DemoConfimationScreen";
import ErrorPopup from "../../components/customPopup/ErrorPopup";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const BookDemoForm = ({
  selectedData,
  handleOpenSuccessPopup,
  handleClose,
  testId,
}) => {
  const userId = localStorage.getItem("userId");
  const [testType, setTestType] = useState(testId || null);
  const [selectedTestTypeName, setSeletedTestTypeName] = useState(null);
  const [testTypeObj, setTestTypeObj] = useState(null);
  const [deliveryMode, setDeliveryMode] = useState(null);
  const [deliveryModeName, setDeliveryModeName] = useState(null);
  const [branch, setBranch] = useState(null);
  const [demoDate, setDemoDate] = useState(null);
  const [formatedDate, setFormatedDate] = useState(null);
  const [examTaken, setExamTaken] = useState(null);
  const [examBooked, setExamBooked] = useState(null);
  const [testTypelIst, setTestTypeList] = useState([]);
  const [SubtestTypelIst, setSubTestTypeList] = useState([]);
  const [subTestType, setSubTestType] = useState(null);
  const [DeliveryModeList, setDeliveryModeList] = useState([]);
  const [sessionLoading, setSessionLoading] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [testDeliveryFormat, setDelivertFormat] = useState(null);
  const [testDeliveryFormatList, setTestDeliveryFormatList] = useState([]);
  const [classId, setClassId] = useState(null);
  const [selectedClassData, setSelectedClassData] = useState(null);
  const [preparationOptions, setPreparationOptions] = useState([
    { value: "self", label: "Self" },
    { value: "other", label: "Other Institute" },
    { value: "none", label: "No Preparation" },
  ]);

  const [preparation, setPreparation] = useState(null);
  const [sessionData, setSessionData] = useState({});
  const [showMessge, setShowMessgae] = useState(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false);
  const [formData, setFormData] = useState({});
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const todaysDate = new Date().toISOString().split("T")[0];
  const today = new Date();
  const maxDate = new Date();
  maxDate.setDate(today.getDate() + 9); // 10 days from today
  useEffect(() => {
    const fetchTestTypes = async () => {
      try {
        const data = await getTestTypeList();
        setTestTypeList(data);
      } catch (err) {
        console.error("Could not fetch test types");
      }
    };

    fetchTestTypes();
  }, []);

  useEffect(() => {
    const fetchSubTestTypes = async () => {
      try {
        const data = await getSubTestTypeList(testType);
        setSubTestTypeList(data?.data);
      } catch (err) {
        console.error("Could not fetch test types");
      }
    };

    fetchSubTestTypes();
  }, [testType]);

  useEffect(() => {
    const fetdeliveryModes = async () => {
      try {
        const data = await getDeliveryModes();
        setDeliveryModeList(data);
      } catch (err) {
        console.error("Could not fetch delivery modes", err);
      }
    };

    fetdeliveryModes();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getTestDeliveryFormat();
        setTestDeliveryFormatList(data);
      } catch (err) {
        console.error("Could not fetch test delivery format", err);
      }
    };

    fetchData();
  }, []);

  // find test type name
  useEffect(() => {
    if (testType && testTypelIst?.length) {
      const testTypeObj = testTypelIst.find((i) => i.id === testType);

      setSeletedTestTypeName(testTypeObj?.name);
      setTestTypeObj(testTypeObj);
    }
  }, [testType, testTypelIst]);

  // find delivery mode name
  useEffect(() => {
    const deliverymodeobj = DeliveryModeList?.find(
      (i) => i.id === deliveryMode
    );
    setDeliveryModeName(deliverymodeobj?.name);
  }, [deliveryMode]);

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const data = await getBranchList();
        setBranchList(data?.data);
      } catch (err) {
        console.error("Could not fetch branches");
      }
    };

    fetchBranch();
  }, []);

  const {
    control,
    handleSubmit,
    setValue,
    trigger,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      test_type_id: testId,
    },
  });

  // List only fields that should validate before search
  const searchFields = [
    "test_type_id",
    "sub_test_type_id",
    "test_delivery_format_id",
    "delivery_mode",
    "branch_id",
    "available_demo_date",
  ];

  const handleSearchDemoClick = async () => {
    // ✅ only validate top fields

    const isValid = await trigger(searchFields);
    if (!isValid) return;

    // Get current form values
    const values = getValues();

    // Call your API / function
    handleSearchDemo(values);
    setExamBooked(null);
    setExamTaken(null);
    setPreparation(null);
    setValue("score", null);
    setValue("tentative_date", null);
    setValue("institute_name", null);
    setValue("exam_already_given", null);
    setValue("is_exam_booked", null);
    setValue("preparation", null);
  };
  //
  const handleSearchDemo = async (data) => {
    try {
      setSessionLoading(true);
      setClassId(null);
      const payload = {
        ...data, // all values from Controller form
        available_demo_date: formatedDate, // ✅ only date part
        user_id: parseInt(userId), // extra field
        test_type_id: testType, // from state
        delivery_mode: deliveryMode, // from state
        branch_id: deliveryModeName === "offline" ? data.branch_id : null,
        same_trainer: null,
        note: null,
        sub_test_type_id: null,
      };

      const response = await searchDemo(payload);
      console.log("response", response);
      if (response.status === 200) {
        // ✅ update parent state with new data
        setSessionData(response?.data);
        if (response?.data?.length === 0) {
          setShowMessgae(true);
        } else {
          setShowMessgae(false);
        }
        setSessionLoading(false);
      } else if ([400, 401, 500].includes(response.status)) {
        setSessionLoading(false);
      }
    } catch (error) {
      setSessionLoading(false);
    }
  };

  const handleChangeClass = (classId, sessionData) => {
    setClassId(classId);
    setSelectedClassData(sessionData);
  };

  const handleOpenConfirmationPopup = () => {
    setOpenConfirmationPopup(true);
  };

  const handleCloseConfirmationPopup = () => {
    setOpenConfirmationPopup(false);
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  const handleValidateForm = async () => {
    if (classId === null) {
      setErrorMessage(
        "You haven’t selected a class slot yet. Please choose a class slot from the list before continuing"
      );
      handleOpenErrorPopup();
      return;
    }
    try {
      const formValues = getValues();
      setFormData({
        ...formValues,
        test_type_name: selectedTestTypeName, // include test type name
        sub_test_type_id:
          SubtestTypelIst?.find((opt) => opt?.test_type_id === testType) ||
          null,
        available_demo_date: formatedDate,
        delivery_mode_name: deliveryModeName, // include delivery mode name if needed
        test_delivery_format:
          testDeliveryFormatList?.find(
            (opt) => opt?.id === testDeliveryFormat
          ) || null,
        branch_id: branchList?.find((opt) => opt.id === branch) || null,
        session_data: selectedClassData,
      });

      //  Open confirmation popup first
      setOpenConfirmationPopup(true);
    } catch (error) {
      console.error(error);
    }
  };

  // Book Demo

  const handleSubmitData = async () => {
    setSubmitLoading(true);
    const formValues = getValues();

    try {
      const payload = {
        ...formValues,
        user_id: parseInt(userId),
        class_id: parseInt(classId),
        slot: selectedClassData?.slots,
        available_demo_date: formatedDate, // ✅ only date part
      };

      const response = await bookDemo(payload);

      if (response.status === 201) {
        setSubmitLoading(false);
        handleClose();
        handleOpenSuccessPopup();
      } else if ([400, 409, 401, 500].includes(response.status)) {
        setSubmitLoading(false);
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      }
    } catch (error) {
      setSubmitLoading(false);
      setErrorMessage("Internal Server Error");
      handleOpenErrorPopup();
    }
  };

  // Function to highlight only the next 10 days
  const highlightNext10Days = (date) => {
    const currentDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const start = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const end = new Date(
      maxDate.getFullYear(),
      maxDate.getMonth(),
      maxDate.getDate()
    );

    if (currentDate >= start && currentDate <= end) {
      return "react-datepicker__day--highlighted-pink";
    }
    return undefined;
  };

  useEffect(() => {
    // ✅ Convert to local date (ignore timezone shift)
    const formattedDate = demoDate
      ? new Date(demoDate).toLocaleDateString("en-CA", {
          timeZone: "Asia/Kolkata",
        }) // "YYYY-MM-DD" in IST
      : null;
    setFormatedDate(formattedDate);
  }, [demoDate]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            sx={{ borderRadius: 3, border: "1px solid #EEEEEE", p: 2, mt: 1 }}
          >
            <Grid container spacing={2}>
              {/* test type */}
              <Grid item xs={12} md={6}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={0.5}
                  mb={1}
                >
                  <DescriptionIcon
                    style={{ color: "#9D0385" }}
                    fontSize="small"
                  />
                  <Typography
                    fontSize="14px"
                    color="#9D0385"
                    sx={{
                      fontWeight: 400,
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      letterSpacing: "0.1px",
                      verticalAlign: "middle",
                      lineHeight: "100%",
                    }}
                  >
                    Test Type <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>

                <Controller
                  name="test_type_id"
                  control={control}
                  rules={{ required: "Test Type is required" }}
                  render={({ field }) => (
                    <CustomSelectField
                      {...field}
                      fullWidth
                      options={testTypelIst}
                      getOptionLabel={(opt) => opt?.name}
                      getOptionValue={(opt) => opt?.id}
                      value={testType}
                      onChange={(e) => {
                        setTestType(e.target.value);
                        setValue("test_type_id", e.target.value);
                        setSubTestType(null);
                        setValue("sub_test_type_id", null);
                        setSessionData([]);
                      }}
                      error={!!errors.test_type_id}
                      helperText={errors.test_type_id?.message}
                    />
                  )}
                />
              </Grid>

              {/* sub test type */}
              {SubtestTypelIst?.length > 0 && (
                <Grid item xs={12} md={6}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={0.5}
                    mb={1}
                  >
                    <DashboardIcon
                      style={{ color: "#9D0385" }}
                      fontSize="small"
                    />
                    <Typography
                      fontSize="14px"
                      color="#9D0385"
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        letterSpacing: "0.1px",
                        verticalAlign: "middle",
                        lineHeight: "100%",
                      }}
                    >
                      Sub Test Type <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </Box>
                  <Controller
                    name="sub_test_type_id"
                    control={control}
                    rules={{
                      required:
                        SubtestTypelIst.length > 0
                          ? "Sub Test Type is required"
                          : false,
                    }}
                    render={({ field }) => (
                      <CustomSelectField
                        {...field}
                        fullWidth
                        options={SubtestTypelIst}
                        value={subTestType}
                        onChange={(e) => {
                          setSubTestType(e.target.value);
                          setValue("sub_test_type_id", e.target.value);
                          setSessionData([]);
                        }}
                        getOptionLabel={(opt) => opt?.name}
                        getOptionValue={(opt) => opt?.id}
                        error={!!errors.sub_test_type_id}
                        helperText={errors.sub_test_type_id?.message}
                      />
                    )}
                  />
                </Grid>
              )}

              {/* Test Delivery Format */}
              {selectedTestTypeName === "IELTS" && (
                <Grid item xs={12} md={6}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={0.5}
                    mb={1}
                  >
                    <BrandingWatermarkIcon
                      style={{ color: "#9D0385" }}
                      fontSize="small"
                    />
                    <Typography
                      fontSize="14px"
                      color="#9D0385"
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        letterSpacing: "0.1px",
                        verticalAlign: "middle",
                        lineHeight: "100%",
                      }}
                    >
                      Test Delivery Format
                    </Typography>
                  </Box>
                  <Controller
                    name="test_delivery_format_id"
                    control={control}
                    // rules={{
                    //   required:
                    //     selectedTestTypeName === "IELTS"
                    //       ? "Test delivery format is required"
                    //       : false,
                    // }}
                    render={({ field }) => (
                      <CustomSelectField
                        {...field}
                        fullWidth
                        options={testDeliveryFormatList}
                        value={testDeliveryFormat}
                        onChange={(e) => {
                          setDelivertFormat(e.target.value);
                          setValue("test_delivery_format_id", e.target.value);
                          setSessionData([]);
                        }}
                        getOptionLabel={(opt) => opt?.name}
                        getOptionValue={(opt) => opt?.id}
                        error={!!errors.test_delivery_format_id}
                        helperText={errors.test_delivery_format_id?.message}
                      />
                    )}
                  />
                </Grid>
              )}

              {/* Delivery Mode */}
              <Grid item xs={12} md={6}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={0.5}
                  mb={1}
                >
                  <DesktopWindowsIcon
                    style={{ color: "#9D0385" }}
                    fontSize="small"
                  />

                  <Typography
                    fontSize="14px"
                    color="#9D0385"
                    sx={{
                      fontWeight: 400,
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      letterSpacing: "0.1px",
                      verticalAlign: "middle",
                      lineHeight: "100%",
                    }}
                  >
                    Delivery Mode <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <Controller
                  name="delivery_mode"
                  control={control}
                  rules={{ required: "Delivery mode is required" }}
                  render={({ field }) => (
                    <CustomSelectField
                      {...field}
                      fullWidth
                      options={DeliveryModeList}
                      value={deliveryMode}
                      onChange={(e) => {
                        setDeliveryMode(e.target.value);
                        setValue("delivery_mode", e.target.value);
                        setSessionData([]);
                      }}
                      getOptionLabel={(opt) => opt?.description}
                      getOptionValue={(opt) => opt?.id}
                      error={!!errors.delivery_mode}
                      helperText={errors.delivery_mode?.message}
                    />
                  )}
                ></Controller>
              </Grid>

              {/* select branch */}
              {deliveryModeName === "offline" && (
                <Grid item xs={12} md={6}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={0.5}
                    mb={1}
                  >
                    <DescriptionIcon
                      style={{ color: "#9D0385" }}
                      fontSize="small"
                    />
                    <Typography
                      fontSize="14px"
                      color="#9D0385"
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        letterSpacing: "0.1px",
                        verticalAlign: "middle",
                        lineHeight: "100%",
                      }}
                    >
                      Branch <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </Box>
                  <Controller
                    name="branch_id"
                    control={control}
                    rules={{
                      required:
                        deliveryModeName === "offline"
                          ? "Branch is required"
                          : false,
                    }}
                    render={({ field }) => (
                      <CustomSelectField
                        {...field}
                        fullWidth
                        options={branchList}
                        value={branch}
                        onChange={(e) => {
                          setBranch(e.target.value);
                          setValue("branch_id", e.target.value);
                          setSessionData([]);
                        }}
                        getOptionLabel={(opt) => opt?.branch_name}
                        getOptionValue={(opt) => opt?.id}
                        error={!!errors.branch_id}
                        helperText={errors.branch_id?.message}
                      >
                        {" "}
                      </CustomSelectField>
                    )}
                  />
                </Grid>
              )}

              {/* Demo Date */}
              <Grid item xs={12} md={6}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={0.5}
                  mb={1}
                >
                  <InsertInvitationIcon
                    style={{ color: "#9D0385" }}
                    fontSize="small"
                  />
                  <Typography
                    fontSize="14px"
                    color="#9D0385"
                    sx={{
                      fontWeight: 400,
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      letterSpacing: "0.1px",
                      verticalAlign: "middle",
                      lineHeight: "100%",
                    }}
                  >
                    Demo Date <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <Controller
                  name="available_demo_date"
                  control={control}
                  rules={{ required: "Demo date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date) => {
                        setDemoDate(date);
                        field.onChange(date); // Updates react-hook-form value
                        setSessionData([]);
                      }}
                      dayClassName={highlightNext10Days}
                      minDate={today}
                      maxDate={maxDate}
                      dateFormat="dd-MM-yyyy"
                      customInput={
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          borderColor="#E6E2F7"
                          size="small"
                          // color="#9D0385"
                          //  fontWeight={700}
                          fontSize={15}
                          error={!!errors.available_demo_date}
                          helperText={errors.available_demo_date?.message}
                          InputProps={{
                            endAdornment: (
                              <CalendarTodayIcon
                                style={{ cursor: "pointer", fontSize: "1rem" }}
                              />
                            ),
                          }}
                        />
                      }
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} textAlign="center" mt={1}>
                <SearchButton
                  text="Search Demo Sessions"
                  onClick={handleSearchDemoClick}
                />
              </Grid>

              {sessionLoading && (
                <Grid item xs={12} textAlign="center">
                  <Loader text="Loading Demo Sessions ..." height="20vh" />
                </Grid>
              )}

              {!sessionLoading && showMessge && (
                <Grid item xs={12} textAlign="center">
                  <Box
                    sx={{
                      background: "#BA15150F",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                  >
                    <InfoIcon style={{ color: "#BA1515" }} />
                    <Typography
                      fontSize="12px"
                      color="#BA1515"
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        lineHeight: "100%",
                        fontStyle: "normal",
                        letterSpacing: "0%",
                      }}
                    >
                      No slots Found here for the Selected Criteria
                    </Typography>
                  </Box>
                </Grid>
              )}

              {!sessionLoading && sessionData?.length > 0 && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      borderRadius: 3,
                      border: "1px solid #EEEEEE",
                      p: 2,
                      mt: 1,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                      mb={1}
                    >
                      <EventAvailableIcon style={{ color: "#A314AA" }} />
                      <Typography
                        fontSize="18px"
                        color="#A314AA"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Available Demo Sessions for {formatedDate}
                      </Typography>
                    </Stack>

                    <Typography
                      textAlign="center"
                      fontSize="14px"
                      color="#444444"
                      mb={1}
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        letterSpacing: "0.1px",
                        verticalAlign: "middle",
                        lineHeight: "100%",
                      }}
                    >
                      We have several slots available on this date. Select a
                      time that works best for you.
                    </Typography>

                    <Grid container spacing={3} mt={2}>
                      {sessionData?.map((session, index) => (
                        <Grid item xs={12} md={4} key={index}>
                          <Card
                            onClick={() =>
                              handleChangeClass(session?.class_id, session)
                            }
                            sx={{
                              border: "1px solid #eee",
                              borderRadius: 2,
                              boxShadow: classId === session?.class_id ? 4 : 1,
                              backgroundColor:
                                classId === session?.class_id
                                  ? "#FAF5FF"
                                  : "#fff",
                              transition: "0.3s",
                              height: "100%",
                              padding: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Stack spacing={2}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Box width={32}>
                                  <img src="/newdashboard/Demo/Group 1171283449.png" />
                                </Box>
                                <Typography
                                  textAlign="center"
                                  fontSize="13px"
                                  color="#000000"
                                  mb={1}
                                  sx={{
                                    fontWeight: 400,
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    letterSpacing: "0.1px",
                                    verticalAlign: "middle",
                                    lineHeight: "100%",
                                  }}
                                >
                                  {session.slots}
                                </Typography>
                              </Stack>

                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Box width={32}>
                                  <img src="/newdashboard/Demo/Group 1171283449 (1).png" />
                                </Box>
                                <Typography
                                  textAlign="center"
                                  fontSize="13px"
                                  color="#000000"
                                  mb={1}
                                  sx={{
                                    fontWeight: 500,
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    letterSpacing: "0.1px",
                                    verticalAlign: "middle",
                                    lineHeight: "100%",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#A314AA",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {" "}
                                    {session?.available_slot}
                                  </span>{" "}
                                  seats available
                                </Typography>
                              </Stack>
                              {/* {session?.branch && (
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <Box width={32}>
                                <img src="/newdashboard/Demo/Group 1171283449 (2).png" />
                              </Box>
                              <Typography
                                textAlign="center"
                                fontSize="13px"
                                color="#000000"
                                mb={1}
                                sx={{
                                  fontWeight: 400,
                                  fontFamily: "Inter",
                                  fontStyle: "normal",
                                  letterSpacing: "0.1px",
                                  verticalAlign: "middle",
                                  lineHeight: "100%",
                                }}
                              >
                                {session.branch}
                              </Typography>
                            </Stack>
                          )} */}
                            </Stack>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>

        {!sessionLoading && sessionData?.length > 0 && (
          <>
            <Grid item xs={12}>
              <Box
                sx={{
                  borderRadius: 3,
                  border: "1px solid #EEEEEE",
                  p: 2,
                  mt: 1,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    {/* <FormControl component="fieldset">
                <Typography
                  fontSize="14px"
                  color="#000000"
                  mb={1}
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    letterSpacing: "0.1px",
                    verticalAlign: "middle",
                    lineHeight: "100%",
                  }}
                >
                  Have you taken exam before ?{" "}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <Controller
                  name="exam_already_given"
                  control={control}
                  rules={{ required: "Selection is required" }}
                  render={({ field }) => (
                    <GlobalRadioGroup
                      {...field}
                      required
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      value={examTaken}
                      onChange={(e) => {
                        setExamTaken(e.target.value);
                        setValue("exam_already_given", e.target.value);
                      }}
                  
                    />
                  )}
                />
              </FormControl> */}
                    <FormControl
                      component="fieldset"
                      error={!!errors.exam_already_given}
                    >
                      <Typography fontSize="14px" color="#000" mb={1}>
                        Have you taken this exam before ?{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <Controller
                        name="exam_already_given"
                        control={control}
                        rules={{ required: "Please choose one option" }}
                        render={({ field }) => (
                          <>
                            <GlobalRadioGroup
                              {...field}
                              options={[
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" },
                              ]}
                              value={examTaken}
                              onChange={(e) => {
                                setExamTaken(e.target.value);
                                setValue("exam_already_given", e.target.value);
                              }}
                            />

                            {/* ✅ show error below radios */}
                            {errors.exam_already_given && (
                              <Typography
                                color="error"
                                fontSize="12px"
                                mt={0.5}
                              >
                                {errors.exam_already_given.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl
                      component="fieldset"
                      error={!!errors.is_exam_booked}
                    >
                      <Typography
                        fontSize="14px"
                        color="#000000"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Have you scheduled your exam ?{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Controller
                        name="is_exam_booked"
                        control={control}
                        rules={{ required: "Please choose one option" }}
                        render={({ field }) => (
                          <>
                            <GlobalRadioGroup
                              {...field}
                              required
                              options={[
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" },
                              ]}
                              value={examBooked}
                              onChange={(e) => {
                                setExamBooked(e.target.value);
                                setValue("is_exam_booked", e.target.value);
                              }}
                            />
                            {errors.is_exam_booked && (
                              <Typography
                                color="error"
                                fontSize="12px"
                                mt={0.5}
                              >
                                {errors.is_exam_booked.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </FormControl>
                  </Grid>

                  {examTaken === "Yes" && (
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontSize="14px"
                        color="#000000"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Please enter your overall band score{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Controller
                        name="score"
                        control={control}
                        rules={{
                          required:
                            examTaken === "Yes"
                              ? "Overall band Score is required"
                              : false,
                          min: {
                            value: testTypeObj?.min_score ?? 0,
                            message: `Score must be at least ${testTypeObj?.min_score}`,
                          },
                          max: {
                            value: testTypeObj?.max_score ?? 9,
                            message: `Score cannot exceed ${testTypeObj?.max_score}`,
                          },
                        }}
                        render={({ field }) => (
                          <CustomTextField
                            {...field}
                            fullWidth
                            type="number"
                            error={!!errors.score}
                            helperText={errors.score?.message}
                            placeholder={`Enter overall band score (${testTypeObj?.min_score}–${testTypeObj?.max_score})`}
                            inputProps={{
                              min: testTypeObj?.min_score,
                              max: testTypeObj?.max_score,
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {examTaken === "No" && (
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontSize="14px"
                        color="#000000"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Please enter your target band score{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Controller
                        name="score"
                        control={control}
                        rules={{
                          required:
                            examTaken === "No"
                              ? "Target band score is required"
                              : false,
                          min: {
                            value: testTypeObj?.min_score ?? 0,
                            message: `Score must be at least ${testTypeObj?.min_score}`,
                          },
                          max: {
                            value: testTypeObj?.max_score ?? 9,
                            message: `Score cannot exceed ${testTypeObj?.max_score}`,
                          },
                        }}
                        render={({ field }) => (
                          <CustomTextField
                            {...field}
                            fullWidth
                            type="number"
                            error={!!errors.score}
                            helperText={errors.score?.message}
                            placeholder={`Enter target band score (${testTypeObj?.min_score}–${testTypeObj?.max_score})`}
                            inputProps={{
                              min: testTypeObj?.min_score,
                              max: testTypeObj?.max_score,
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {examBooked === "Yes" && (
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontSize="14px"
                        color="#000000"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Please select your exam date{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Controller
                        name="tentative_date"
                        control={control}
                        rules={{
                          required:
                            examBooked === "Yes"
                              ? "Exam date is required"
                              : false,
                        }}
                        render={({ field }) => (
                          <CustomTextField
                            {...field}
                            fullWidth
                            type="date"
                            error={!!errors.tentative_date}
                            helperText={errors.tentative_date?.message}
                            inputProps={{
                              min: todaysDate, // disable all dates after today
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {examBooked === "No" && (
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontSize="14px"
                        color="#000000"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Please select your tentative exam date{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Controller
                        name="tentative_date"
                        control={control}
                        rules={{
                          required:
                            examBooked === "No"
                              ? "Tentative exam date is required"
                              : false,
                        }}
                        render={({ field }) => (
                          <CustomTextField
                            {...field}
                            fullWidth
                            type="date"
                            error={!!errors.tentative_date}
                            helperText={errors.tentative_date?.message}
                            inputProps={{
                              min: todaysDate, // disable all dates after today
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {/* preparation field */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      fontSize="14px"
                      color="#000000"
                      mb={1}
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        letterSpacing: "0.1px",
                        verticalAlign: "middle",
                        lineHeight: "100%",
                      }}
                    >
                      How did you prepare for the test ?{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                      name="preparation"
                      control={control}
                      rules={{
                        required: "Peparation is required",
                      }}
                      render={({ field }) => (
                        <CustomSelectField
                          {...field}
                          fullWidth
                          options={preparationOptions}
                          getOptionLabel={(opt) => opt?.label}
                          getOptionValue={(opt) => opt?.value}
                          value={preparation}
                          onChange={(e) => {
                            setPreparation(e.target.value);
                            setValue("preparation", e.target.value);
                          }}
                          error={!!errors.preparation}
                          helperText={errors.preparation?.message}
                        />
                      )}
                    />
                  </Grid>

                  {/* institute name */}
                  {preparation === "other" && (
                    <Grid item xs={12} md={6}>
                      <Typography
                        fontSize="14px"
                        color="#000000"
                        mb={1}
                        sx={{
                          fontWeight: 400,
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          letterSpacing: "0.1px",
                          verticalAlign: "middle",
                          lineHeight: "100%",
                        }}
                      >
                        Please enter institute name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <Controller
                        name="institute_name"
                        control={control}
                        rules={{
                          required:
                            preparation === "other"
                              ? "Institute name is required"
                              : false,
                        }}
                        render={({ field }) => (
                          <CustomTextField
                            {...field}
                            fullWidth
                            type="text"
                            error={!!errors.institute_name}
                            helperText={errors.institute_name?.message}
                          />
                        )}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} textAlign="center">
              <PrimaryButon
                text="Book Demo"
                // onClick={handleSubmit(handleSubmitData)}
                onClick={handleSubmit(() => handleValidateForm())}
              />
            </Grid>
          </>
        )}
      </Grid>

      <ConfirmationScreen
        handleClose={handleCloseConfirmationPopup}
        component={
          <DemoConfimationScreen
            handleClose={handleCloseConfirmationPopup}
            formData={formData}
            handleSubmitData={handleSubmitData}
            submitLoading={submitLoading}
          />
        }
        open={openConfirmationPopup}
        title="Confirm Your Demo sessions"
        titleColor="#000000"
        maxWidth="sm"
        titleAlign="center"
        imgSrc="/newdashboard/Demo/Group 1171283465.png"
      />

      <ConfimationPopup
        handleClose={handleCloseErrorPopup}
        component={
          <ErrorPopup
            handleClose={handleCloseErrorPopup}
            const
            text="Error"
            subText={errorMessage}
            buttonTitle="Continue"
            // startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
          />
        }
        open={openErrorPopup}
        subtitle=""
        maxWidth="xs"
      />
    </>
  );
};

export default BookDemoForm;
